import { Announcement } from '@app/core/interfaces/c5/announcement';
import { AnnouncementType } from '@app/core/interfaces/c5/announcement-type';
import { calculateAnnouncementGroup } from '@app/shared/acd-cc/utils/calculate-announcement-group';
import { EnhancedAnnouncement } from '@app/shared/acd-cc/utils/route-config/enhanced-announcement';

export function mapAnnouncements(
  announcements: Announcement[],
  mode: 'acd' | 'cc' = 'acd'
): EnhancedAnnouncement[] {
  return announcements
    .filter((announcement) => {
      return announcement.type === AnnouncementType.ACD || announcement.type === AnnouncementType.DOMAIN;
    })
    .map((announcement: EnhancedAnnouncement) => {
      return {
        ...announcement,
        groupLabel: calculateAnnouncementGroup(announcement, mode),
      };
    });
}
